module.exports = __webpack_public_path__ + "img/141.300c1719.png";